import { ShieldCheck, Server, Lock, RefreshCw, MapPin } from "lucide-react";

/**
 * Trust badges section — appears under Hero/ROI to reassure cautious B2B
 * buyers about data security. Cleaning industry is high-trust (keys, codes,
 * customer access) so this is critical to address up-front.
 */
const badges = [
    { icon: MapPin, title: "Bygget i Danmark", desc: "Dansk team, dansk support — ingen udenlandske middlemænd." },
    { icon: Server, title: "Data hostet i EU/EØS", desc: "Alle data lagres i certificerede datacentre i Europa." },
    { icon: ShieldCheck, title: "100% GDPR-compliant", desc: "Databehandleraftale automatisk ved opstart." },
    { icon: Lock, title: "Krypteret end-to-end", desc: "TLS 1.3 i transit, AES-256 i hvile." },
    { icon: RefreshCw, title: "Daglig backup", desc: "Auto-backup hver nat. Op til 30 dages historik." },
];

export default function TrustBadges() {
    return (
        <section className="py-12 md:py-16 bg-white border-y border-slate-200" data-testid="trust-badges">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="text-center max-w-2xl mx-auto mb-10">
                    <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 border border-emerald-100 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-emerald-700">
                        <ShieldCheck className="h-3 w-3" />
                        Sikkerhed & Compliance
                    </div>
                    <h2 className="mt-4 font-display text-xl md:text-2xl font-bold text-slate-900 tracking-tight">
                        Bygget med sikkerhed i centrum — fordi I håndterer kundernes nøgler.
                    </h2>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                    {badges.map((b) => (
                        <div
                            key={b.title}
                            className="rounded-xl border border-slate-200 bg-slate-50/40 p-4 hover:bg-slate-50 hover:border-slate-300 transition-colors"
                            data-testid={`trust-badge-${b.title}`}
                        >
                            <div className="h-9 w-9 rounded-lg bg-white border border-slate-200 flex items-center justify-center text-slate-700 shadow-sm">
                                <b.icon className="h-4 w-4" strokeWidth={2} />
                            </div>
                            <div className="mt-3 text-sm font-bold text-slate-900 leading-tight">
                                {b.title}
                            </div>
                            <div className="mt-1 text-[12px] text-slate-600 leading-snug">
                                {b.desc}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
